export default {
    items: [
        {
            name: 'Dashboard',
            type: 'dashboard',
            route: 'dashboard',
            iconClasses: ['font-icon', 'font-icon-dashboard'],
            iconClass: 'material-icons',
            iconName: 'dashboard',
            color: 'navy',
        },
        {
            name: 'Content',
            children: [
                { name: 'Pages', route: 'pages', type: 'page' },
                { name: 'Panel library', route: 'panels', type: 'panel' },
            ],
            iconClass: 'material-icons',
            iconName: 'content_copy',
            color: 'navy',
        },
        // {
        //     name: 'News',
        //     route: 'posts',
        //     type: 'post',
        //     iconClass: 'material-icons',
        //     iconName: 'perm_media',
        //     color: 'navy',
        // },
        {
            name: 'Assets',
            route: 'assets',
            type: 'asset',
            iconClass: 'material-icons',
            iconName: 'photo_album',
            color: 'navy',
        },
        {
            name: 'Products',
            children: [
                { name: 'Products', route: 'products', type: 'product' },
                { name: 'Make Models', route: 'make_models', type: 'make_model' },
                { name: 'Attributes', route: 'product_attributes', type: 'product_attribute' },
                { name: 'Categories', route: 'categories', type: 'category' },
                { name: 'Brands', route: 'brands', type: 'brand' },
            ],
            iconClass: 'material-icons',
            iconName: 'store',
            color: 'navy',
        },
        {
            name: 'Customers',
            children: [
                { name: 'Customers', route: 'customers', type: 'customer' },
                { name: 'Logins', route: 'customer_logins?filter=approved:1', type: 'customer_login' },
                { name: 'Pending Registrations', route: 'customer_logins?filter=approved:0', type: 'customer_login' },
            ],
            // type: 'customer',
            // route: 'customers',
            iconClass: 'material-icons',
            iconName: 'perm_contact_calendar',
            color: 'navy',
        },
        {
            name: 'Enquiries',
            children: [
                { name: 'Enquiries', route: 'enquiries', type: 'enquiry' },
                { name: 'Subscribers', route: 'subscribers', type: 'subscriber' },
            ],
            iconClass: 'material-icons',
            iconName: 'forum',
            color: 'navy',
        },
        {
            name: 'Orders',
            type: 'order',
            route: 'orders',
            iconClass: 'material-icons',
            iconName: 'assignment',
            color: 'navy',
        },
        {
            name: 'Accounts',
            children: [
                { name: 'Users', route: 'users', type: 'user' },
                { name: 'Roles', route: 'roles', type: 'role' },
            ],
            iconClass: 'material-icons',
            iconName: 'account_box',
            color: 'navy',
        },
        {
            name: 'Settings',
            children: [
                { name: 'Settings', route: 'settings', type: 'setting' },
                { name: 'Redirect URLs', route: 'redirect_urls', type: 'redirect_url' },
            ],
            iconClass: 'material-icons',
            iconName: 'settings',
            color: 'navy',
        },
    ],
    defaultItem: 'Content',
}